var exports = {
  "K": "shared.module__icon___NlF4T1",
  "B": "shared.module__iconSmall___NlF4T1",
};

module.exports = exports;
